export default __webpack_public_path__ + "static/media/gallery_04.bf45a522.jpg";